import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a6a21d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary-layout" }
const _hoisted_2 = { class: "summary-layout-wrapper" }
const _hoisted_3 = { class: "summary-layout__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Итого", -1))
const _hoisted_5 = { class: "summary-layout__prices" }
const _hoisted_6 = { class: "rouble-symbol" }
const _hoisted_7 = { class: "summary-layout__info summary-layout__product-count" }
const _hoisted_8 = { class: "left" }
const _hoisted_9 = { class: "rouble-symbol right" }
const _hoisted_10 = {
  key: 0,
  class: "summary-layout__discounts discounts"
}
const _hoisted_11 = {
  key: 0,
  class: "summary-layout__info discounts__info"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left" }, "по акции", -1))
const _hoisted_13 = { class: "rouble-symbol right" }
const _hoisted_14 = {
  key: 1,
  class: "summary-layout__info discounts__info"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left" }, "по промокоду", -1))
const _hoisted_16 = { class: "rouble-symbol right" }
const _hoisted_17 = {
  key: 2,
  class: "summary-layout__info discounts__info"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left" }, "будет начислено бонусов", -1))
const _hoisted_19 = { class: "right" }
const _hoisted_20 = {
  key: 3,
  class: "summary-layout__info discounts__info"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left" }, "будет списано бонусов", -1))
const _hoisted_22 = { class: "right" }
const _hoisted_23 = {
  key: 4,
  class: "summary-layout__info discounts__info"
}
const _hoisted_24 = { class: "left" }
const _hoisted_25 = { class: "rouble-symbol right" }
const _hoisted_26 = {
  key: 0,
  class: "delivery-prices"
}
const _hoisted_27 = {
  key: 0,
  class: "summary-layout__info"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left" }, "Доставка", -1))
const _hoisted_29 = { class: "rouble-symbol summary-layout__black-text right" }
const _hoisted_30 = { class: "left" }
const _hoisted_31 = { class: "rouble-symbol summary-layout__black-text right" }
const _hoisted_32 = {
  key: 1,
  class: "summary-layout__info summary-layout__delivery-time"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left" }, " Время доставки ", -1))
const _hoisted_34 = { class: "summary-layout__black-text right" }
const _hoisted_35 = { class: "summary-layout__delivery-address" }
const _hoisted_36 = { class: "rouble-symbol" }
const _hoisted_37 = {
  key: 3,
  class: "summary-layout__stocks stocks"
}
const _hoisted_38 = { class: "stocks__bonuses radio radio--square" }
const _hoisted_39 = ["checked"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "radio__label" }, " Использовать бонусы ", -1))
const _hoisted_41 = { class: "stocks__coupon radio radio--square" }
const _hoisted_42 = ["checked"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "radio__label" }, " Промокод ", -1))
const _hoisted_44 = {
  key: 4,
  class: "stop-price-message-block"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stop-price-message-block__icon" }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stop-price-message-block__message" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "stop-price-message-block__message-regular" }, "Финальная цена"),
  /*#__PURE__*/_createTextVNode(" — на блюда в корзине не действуют скидки и бонусы ")
], -1))
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = { class: "summary-layout__process-btn-wrapper" }
const _hoisted_49 = {
  key: 0,
  class: "server-error error"
}
const _hoisted_50 = /*#__PURE__*/_createStaticVNode("<div class=\"summary-layout__payment-systems payment-systems\" data-v-7a6a21d0><div class=\"payment-systems__visa\" data-v-7a6a21d0></div><div class=\"payment-systems__mastercard\" data-v-7a6a21d0></div><div class=\"payment-systems__mir\" data-v-7a6a21d0></div><div class=\"payment-systems__sbp\" data-v-7a6a21d0></div></div>", 1)
const _hoisted_51 = { class: "np-panel-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CouponPanel = _resolveComponent("CouponPanel")!
  const _component_BonusesPanel = _resolveComponent("BonusesPanel")!
  const _component_MoPreloader = _resolveComponent("MoPreloader")!
  const _component_NumberPhonePanel = _resolveComponent("NumberPhonePanel")!
  const _component_SBPPanel = _resolveComponent("SBPPanel")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.orderStore.activeOrder.totalPrice)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.orderStore.totalItemsQuantity) + " " + _toDisplayString(_ctx.pluralize(_ctx.orderStore.totalItemsQuantity, ['блюдо', 'блюда', 'блюд'])) + " в корзине ", 1),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.orderStore.activeOrder.totalPriceWithoutDiscount)), 1)
      ]),
      (
          _ctx.orderStore.activeOrder.totalDiscount > 0
            || _ctx.orderStore.activeOrder.totalCardDiscount > 0
            || _ctx.orderStore.activeOrder.couponDiscount > 0
            || _ctx.orderStore.activeOrder.bonusesAccrualSum > 0
            || _ctx.orderStore.activeOrder.bonusesWriteOffSum > 0
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_ctx.orderStore.activeOrder.totalDiscount > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, "-" + _toDisplayString(_ctx.$filters.formattedNumber(_ctx.orderStore.activeOrder.totalDiscount)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.orderStore.activeOrder.couponDiscount > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, "-" + _toDisplayString(_ctx.$filters.formattedNumber(_ctx.orderStore.activeOrder.couponDiscount)), 1)
                ]))
              : _createCommentVNode("", true),
            (+_ctx.orderStore.activeOrder.bonusesAccrualSum > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.orderStore.activeOrder.bonusesAccrualSum)) + " ББ", 1)
                ]))
              : _createCommentVNode("", true),
            (+_ctx.orderStore.activeOrder.bonusesWriteOffSum > 0 && (_ctx.stockType === _ctx.STOCKS.bonuses))
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.orderStore.activeOrder.bonusesWriteOffSum)) + " ББ", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.orderStore.activeOrder.totalCardDiscount > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.CARD_TYPE_TITLES[_ctx.orderStore.activeOrder.cardType]), 1),
                  _createElementVNode("span", _hoisted_25, "-" + _toDisplayString(_ctx.$filters.formattedNumber(_ctx.orderStore.activeOrder.totalCardDiscount)), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isVisibleDeliveryBlock)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["summary-layout__delivery-terms delivery-block", {'delivery-block--with-top-border': _ctx.isVisibleDeliveryTopBorder}])
          }, [
            (_ctx.orderStore.deliveryPrices.main || _ctx.orderStore.deliveryPrices.isVisibleRestaurants)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  (_ctx.orderStore.deliveryPrices.main)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.orderStore.deliveryPrices.main)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.orderStore.deliveryPrices.isVisibleRestaurants)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.orderStore.deliveryPrices.restaurants, (restaurant) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: restaurant.id,
                          class: "summary-layout__info"
                        }, [
                          _createElementVNode("span", _hoisted_30, " Доставка «" + _toDisplayString(restaurant.name) + "» ", 1),
                          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$filters.formattedNumber(restaurant.price)), 1)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.orderStore.deliveryTime)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.orderStore.deliveryTime), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.orderStore.deliveryAddress), 1)
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.orderStore.priceForDelivery)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["summary-layout__delivery-terms delivery-terms", {'summary-layout__delivery-terms--error': _ctx.orderStore.processBtnWasClicked}])
          }, [
            _createTextVNode(" Закажите еще на "),
            _createElementVNode("b", _hoisted_36, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.orderStore.priceForDelivery)), 1),
            _createTextVNode(" для " + _toDisplayString(_ctx.orderStore.activeOrder.deliveryPrice ? '' : 'бесплатной') + " доставки или выберите другой адрес ", 1)
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.hasBonusPoints && !_ctx.isEveryOrderItemStopPrice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createElementVNode("label", _hoisted_38, [
              _createElementVNode("input", {
                id: "bonuses",
                class: "radio__input",
                type: "radio",
                checked: _ctx.stockType === _ctx.STOCKS.bonuses,
                onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleStock(_ctx.STOCKS.bonuses)))
              }, null, 40, _hoisted_39),
              _hoisted_40
            ]),
            _createElementVNode("label", _hoisted_41, [
              _createElementVNode("input", {
                id: "coupon",
                class: "radio__input",
                type: "radio",
                checked: _ctx.stockType === _ctx.STOCKS.coupon,
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleStock(_ctx.STOCKS.coupon)))
              }, null, 40, _hoisted_42),
              _hoisted_43
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isEveryOrderItemStopPrice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_47))
        : _createCommentVNode("", true),
      (_ctx.isMounted && _ctx.stockType === _ctx.STOCKS.coupon)
        ? (_openBlock(), _createBlock(_component_CouponPanel, {
            key: 5,
            coupon: _ctx.orderStore.activeOrder?.coupon,
            "error-message": _ctx.errorCouponMessage,
            "is-loading": _ctx.isLoadingCoupon,
            onApply: _ctx.applyCoupon,
            onReset: _ctx.resetCoupon
          }, null, 8, ["coupon", "error-message", "is-loading", "onApply", "onReset"]))
        : _createCommentVNode("", true),
      (_ctx.isMounted && _ctx.stockType === _ctx.STOCKS.bonuses && !_ctx.isEveryOrderItemStopPrice)
        ? (_openBlock(), _createBlock(_component_BonusesPanel, {
            key: 6,
            "is-loading": _ctx.isLoadingBonuses,
            "error-message": _ctx.errorBonusesMessage,
            "bonuses-write-off-sum": _ctx.orderStore.activeOrder.bonusesWriteOffSum,
            "bonuses-max-write-off-sum": _ctx.orderStore.activeOrder.bonusesMaxWriteOffSum,
            balance: _ctx.authStore.bonusInfo?.balance,
            onApply: _ctx.applyBonuses,
            onReset: _ctx.resetBonuses
          }, null, 8, ["is-loading", "error-message", "bonuses-write-off-sum", "bonuses-max-write-off-sum", "balance", "onApply", "onReset"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("button", {
          class: _normalizeClass(["summary-layout__process-btn base-btn", {
            'base-btn--black': !_ctx.orderStore.clientValidationError,
            'base-btn--red': _ctx.orderStore.clientValidationError,
            'base-btn--disabled': _ctx.orderStore.priceForDelivery && _ctx.orderStore.processBtnWasClicked,
            'base-btn--blocked': _ctx.orderStore.isLoading,
          }]),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.process && _ctx.process(...args)))
        }, [
          (_ctx.orderStore.isLoaderVisible)
            ? (_openBlock(), _createBlock(_component_MoPreloader, {
                key: 0,
                "is-multiple": true
              }))
            : (_ctx.orderStore.clientValidationError)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.buttonTitleError), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(_toDisplayString(_ctx.buttonTitle), 1)
                ], 64))
        ], 2),
        (_ctx.orderStore.serverValidationError?.detail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.orderStore.serverValidationError.detail), 1))
          : _createCommentVNode("", true)
      ]),
      _hoisted_50
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createVNode(_component_NumberPhonePanel, {
        phones: _ctx.companyStore.activeCompany.phones,
        "logo-url": 
          _ctx.companyStore.activeCompany.additionalLogoUrl
            || _ctx.companyStore.activeCompany.logoUrl
        
      }, null, 8, ["phones", "logo-url"])
    ]),
    (_ctx.paymentTypeStore.isOpenSBPModal)
      ? (_openBlock(), _createBlock(_component_ModalDialog, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_SBPPanel, {
              "total-price": _ctx.payment.price,
              "qr-code-img": _ctx.payment.sbpQrImg,
              "allow-send-at": new Date(_ctx.payment.expireAt),
              "error-text": _ctx.paymentErrorText,
              onTimeOver: _cache[3] || (_cache[3] = () => _ctx.setPaymentError(_ctx.PAYMENT_ERRORS.timeOut)),
              onCheckPayment: _ctx.checkPayment,
              onClose: _ctx.paymentTypeStore.closeSbpModal,
              onRetry: _ctx.process,
              onProcess: _ctx.processSbp
            }, null, 8, ["total-price", "qr-code-img", "allow-send-at", "error-text", "onCheckPayment", "onClose", "onRetry", "onProcess"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}